import React, { memo } from 'react';
import { type TagItemProps } from './TagList.d'

const TagItem: React.FC<TagItemProps> = ({ 
  text, 
  isActive, 
  onClick, 
  className, 
  activeClasses = " bg-primary hover:bg-primary text-[#ffffff]", 
  inactiveClasses  = "bg-[#EEEEEE] "
}) => {
  const baseClasses = "gap-2.5 self-stretch px-4 py-1.5 my-auto whitespace-nowrap rounded-[50px] transition-colors duration-200 text-[13px] text-[#777777]";

  return (
    <button
      type="button"
      className={` font-medium 
        ${baseClasses}
        ${isActive ? activeClasses : inactiveClasses}
        ${className}
      `}
      onClick={onClick}
      aria-pressed={isActive}
    >
      {text}
    </button>
  );
};

export default memo(TagItem);
